import { CustomerModalKeys } from "components/CustomerModal/queryKeys";
import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { ApiInstance } from "utils/Api";

import type { COMMUNICATION_CHANNELS } from "models";

type CustomerPayload = {
  id: number;
  is_internal: boolean;
  block_communication: boolean;
  preferred_communication_channel: COMMUNICATION_CHANNELS;
};

export const useUpdateCustomerMutation = () =>
  useTypedMutation<CustomerPayload, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/customers/update", payload, ENV.dealerBaseURL);
    },
    onSuccess: ({ block_communication, is_internal, preferred_communication_channel }) => {
      const customerWithServiceDetails = typedQueryClient.getQueryData(CustomerModalKeys.customerWithServiceDetails);
      if (!customerWithServiceDetails) return;

      typedQueryClient.setQueryData(CustomerModalKeys.customerWithServiceDetails, {
        ...customerWithServiceDetails,
        block_communication,
        is_internal,
        preferred_communication_channel
      });
    }
  });
